import apiClient from '../apiClient';
import { GET_AREA_LIST_URL } from '../apiUrl';

const getAreaListApi = () => {
  return apiClient.get(GET_AREA_LIST_URL);
};

export default getAreaListApi;
